import { Project } from '@/store/types'
import { DEFAULT_SHIMEBI } from '@/tcw/constant/TcwConstant'

export default class Shimebi {
  private val: number | null
  private getsumatsuFlg: boolean

  constructor(val: number | null, getsumatsuFlg: boolean) {
    this.val = val
    this.getsumatsuFlg = getsumatsuFlg
  }

  public static generateByProject(project: Project | null): Shimebi {
    let shimebi = DEFAULT_SHIMEBI
    let getsumatsuShimebi = false
    if (project) {
      shimebi = Number(project.shimebi)
      getsumatsuShimebi = project.getsumatsuShimebi
    }
    return new Shimebi(shimebi, getsumatsuShimebi)
  }
  public static default(): Shimebi {
    return new Shimebi(DEFAULT_SHIMEBI, false)
  }

  public isNextGetsudo(date: Date): boolean {
    if (this.getsumatsuFlg) {
      return false
    }
    if (!this.val) {
      return false
    }
    return date.getDate() > this.val
  }

  public get isGetsumatsu(): boolean {
    return this.getsumatsuFlg
  }
}
